$iconSize: 11, 12, 13, 14, 16, 18, 20, 24, 32, 36, 48;

.inventory {
  &-icon {
    color: var(--grey-layout-200-disabled);
    margin-right: var(--spacer);
  }

  &-label {
    display: none;
    color: var(--chart-300-icon-buttons);
  }

  &-value {
    color: var(--main-titles-inputs-600);

    span {
      font-family: var(--font-family-secondary-mono);
    }
  }

  &.tooltip {
    margin-right: var(--spacer);
  }
}

.inventory-tooltip {
  height: 20px;
}

:host([value]) {
  .inventory {
    &-icon {
      color: var(--chart-302-icon-buttons-titles);
    }
  }
}

:host([icon='ds-icon-entity_endpoint']) {
  gz-tooltip {
    margin-top: -9px;
  }

  .inventory-icon {
    font-size: 30px !important;
  }
}

@each $size in $iconSize {
  :host([iconSize='#{$size}']) {
    .inventory {
      &-icon {
        font-size: #{$size}px;
      }
    }
  }
}

@media screen and (min-width: 2559px) {
  .inventory-label {
    display: block;
    white-space: nowrap;
    margin-right: var(--spacer);
  }

  .inventory-tooltip {
    pointer-events: none;
  }
}
